import "./Login.css";
import "./ResponsiveLogin.css";
import logo from "./logo.jpg";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import LanguageSelect from "../LanguageSelection/LanguageSelect.js";
import { NavLink } from "react-router-dom";
import { useState } from "react";

function Login() {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [eye, setEye] = useState(true);

  const Eye = () => {
    if (passwordType == "password") {
      setPasswordType("text");
      setEye(false);
    } else {
      setPasswordType("password");
      setEye(true);
    }
  };

  const onChangeInput = (event, InputID) => {
    document.getElementById(InputID).classList.remove("is-invalid");
    if (InputID === "LoginAdminUserName") {
      setUserName(event.target.value);
    } else if (InputID === "LoginAdminPassword") {
      setPassword(event.target.value);
    }
  };

  const checkInput = (e) => {
    e.preventDefault();
    if (userName === "" || password === "") {
      if (userName === "")
        document
          .getElementById("LoginAdminUserName")
          .classList.add("is-invalid");
      if (password === "")
        document
          .getElementById("LoginAdminPassword")
          .classList.add("is-invalid");
    } else {
      document.getElementById("login-hidden-btn").click();
    }
  };

  return (
    <div className="Login-form" dir="auto">
      <div className="Login-container">
        <div className="login-form-header-language">
          {/* Language Selection */}
          <LanguageSelect />
        </div>

        <div className="login-admin-web-name">
          <img src={logo} className="login-logo" />
          <div className="logo-text">
            <span className="Login-form-header">{"خدمات التنظيف "}</span>
            <span className="login-Saudi">السعودية</span>
          </div>
        </div>

        {/* Login Form */}
        <form className="Login-form-inputs">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              id="LoginAdminUserName"
              onChange={(event) => onChangeInput(event, "LoginAdminUserName")}
              placeholder={translate("login-user-name-placeholder", locale)}
              aria-describedby="emailHelp"
              dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
            />
            <div className="invalid-feedback">يرجى إدخال اسم المستخدم</div>
          </div>
          <div
            className="mb-3"
            dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
          >
            <input
              type={passwordType}
              className="form-control"
              id="LoginAdminPassword"
              onChange={(event) => onChangeInput(event, "LoginAdminPassword")}
              placeholder={translate("login-password-placeholder", locale)}
            />
            <i
              onClick={Eye}
              className={`eye-pass fa ${eye ? "fa-eye-slash" : "fa-eye"}`}
            ></i>
            <div className="invalid-feedback">يرجى إدخال كلمة السر</div>
          </div>
          <div className="login-admin-buttons">
            <NavLink
              to="/Navbar/Statistics"
              id="login-hidden-btn"
              style={{ display: "none" }}
            ></NavLink>
            <button
              type="submit"
              className="btn btn-primary btn-login-form"
              onClick={checkInput}
            >
              {translate("login-btn-text", locale)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
